// Status de contratos que desabilitam edição
export const DISABLED_CONTRACT_STATUSES = new Set([
    'Suspenso',
    'Cancelado',
    'Finalizado com sucesso',
    'Expirado',
    'Aditado'
]);

// Mapeamento de status para statusId do BadgeRegistrationStatus
// 1=Gerado, 2=Aguardando partes, 3=Em andamento, 4=Suspenso, 5=Cancelado, 6=Finalizado com sucesso, 7=Expirado
const STATUS_ID_MAP: Record<string, number> = {
    'Gerado': 1,
    'Aguardando partes': 2,
    'Em andamento': 3,
    'Suspenso': 4,
    'Cancelado': 5,
    'Finalizado com sucesso': 6,
    'Expirado': 7
};

const DEFAULT_STATUS_ID = 1;

/**
 * Verifica se o formulário deve ser desabilitado baseado no status do contrato
 * @param status - Status atual do contrato
 * @returns true se o formulário deve ser desabilitado
 */
export const isContractDisabled = (status?: string | null): boolean => {
    if (!status) return false;
    return DISABLED_CONTRACT_STATUSES.has(status);
};

/**
 * Retorna o statusId para o BadgeRegistrationStatus baseado no status do contrato
 * @param status - Status atual do contrato
 * @returns statusId correspondente (1-7)
 */
export const getStatusId = (status?: string | null): number => {
    if (!status) return DEFAULT_STATUS_ID;
    return STATUS_ID_MAP[status] ?? DEFAULT_STATUS_ID;
};

/**
 * Retorna a cor do badge baseada no status do contrato
 * @param status - Status atual do contrato
 * @returns cor do badge
 */
export const getStatusColor = (status?: string | null): 'blue' | 'green' | 'red' | 'orange' | 'gray' | 'yellow' | 'purple' | 'indigo' | 'pink' => {
    const STATUS_COLOR_MAP: Record<string, 'blue' | 'green' | 'red' | 'orange' | 'gray' | 'yellow' | 'purple' | 'indigo' | 'pink'> = {
        'Gerado': 'blue',
        'Aguardando partes': 'blue',
        'Em andamento': 'gray',
        'Suspenso': 'yellow',
        'Cancelado': 'red',
        'Finalizado com sucesso': 'green',
        'Expirado': 'red',
        'Aditado': 'purple'
    };
    
    if (!status) return 'blue';
    return STATUS_COLOR_MAP[status] ?? 'blue';
};
